export default "__VITE_ASSET__b56b87ca__"